import find from "lodash/find";
import get from "lodash/get";

import { isCursorStuck } from "../selectors/questionnaire";
import { SET_CURSOR_NEXT } from "../types";
import { isQuestionAnswered } from "../../utils/required";
import { QUESTIONNAIRE_STATUS, STATUS_COMPLETED } from "../status";
import { QUESTION_NOT_FOUND, QUESTION_REQUIRED } from "../userErrors";
import addUserError from "./addUserError";
import pushResponse from "./pushResponse";
import setAppStatus from "./setAppStatus";

function setCursorNext(blocks, questions, payload, params) {
  return {
    blocks,
    questions,
    payload,
    params,
    type: SET_CURSOR_NEXT
  };
}

const finalizeSurvey = () => dispatch => {
  const onSuccess = () =>
    dispatch(setAppStatus(QUESTIONNAIRE_STATUS, STATUS_COMPLETED));

  dispatch(pushResponse({ force: true, verbose: true }, onSuccess));
};

export default function(blocks, questions, payload, current, getState) {
  const question = find(questions, { name: current });

  if (!question) {
    return dispatch => {
      dispatch(addUserError(QUESTION_NOT_FOUND, current));
    };
  }

  const localAnswer = payload.answer[question.name].answer;
  const localContext = payload.context[question.name];

  // Retrieve query parameters passed by user
  const params = get(getState(), 'params', {});

  // Check question required status unless this check is not enforced
  const enforceRequired = get(params, 'questionRequiredLogic', true);
  if (enforceRequired && !isQuestionAnswered(question, localAnswer, localContext)) {
    return dispatch => {
      dispatch(addUserError(QUESTION_REQUIRED, current));
    };
  } else {
    return dispatch => {
      const oldCursor = get(getState(), 'cursor');

      // Go to next question in flow taking into account parameters passed
      const blockDisplayLogic = get(params, 'blockDisplayLogic', true);
      const questionDisplayLogic = get(params, 'questionDisplayLogic', true);
      dispatch(setCursorNext(blocks, questions, payload, { blockDisplayLogic, questionDisplayLogic }));

      const newCursor = get(getState(), 'cursor');
    
      if (isCursorStuck(oldCursor, newCursor)) {
        dispatch(finalizeSurvey());
      }
    };
  }
}
